import { Component } from '@angular/core';


import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { Observable, of } from 'rxjs';
import { FINANCING_PLANS } from './financing-plans.const';

@Component({
  selector: 'app-financing-plans',
  standalone: true,
  imports: [MainLayoutComponent],
  templateUrl: './financing-plans.component.html',
  styleUrl: './financing-plans.component.scss',
})
export class FinancingPlansComponent {
  plans: any[] = FINANCING_PLANS;

  constructor() {}

  onClickBack = (): Observable<any> => {
    return of(true);
  };
}
